import React from 'react';

export type DisplaySizeType = 'desktopLg' | 'desktop' | 'tablet' | 'mobile';

export default React.createContext<DisplaySizeType>('desktop');
